(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["newsletter"] && !Shopify.designMode) return;
  try {
    
function revealNewsletterFeedback() {
  document.querySelectorAll('.newsletter [data-newsletter-feedback]').forEach(function (message) {
    message.focus({ preventScroll: true });
    message.scrollIntoView({ behavior: 'auto', block: 'center' });
  });
}
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', revealNewsletterFeedback, { once: true });
} else {
  revealNewsletterFeedback();
}
document.addEventListener('shopify:section:load', revealNewsletterFeedback);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ng-benefits"] && !Shopify.designMode) return;
  try {
    
function initBenefitsBoxes(root) {
  root.querySelectorAll('[data-benefits-box]').forEach(function(box) {
    const button = box.querySelector('[data-benefits-toggle]');
    if (button.dataset.ready) return;
    button.dataset.ready = 'true';
    button.hidden = false;
    const items = Array.from(box.querySelectorAll('details'));
    function updateLabel() { button.textContent = items.every(item => item.open) ? button.dataset.labelHide : button.dataset.labelShow; }
    button.addEventListener('click', function() {
      const open = !items.every(item => item.open);
      items.forEach(item => { item.open = open; });
      updateLabel();
    });
    items.forEach(item => item.addEventListener('toggle', updateLabel));
  });
}
initBenefitsBoxes(document);
document.addEventListener('shopify:section:load', event => initBenefitsBoxes(event.target));

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ng-storefront"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('ng-storefront')) {
    customElements.define('ng-storefront', class extends HTMLElement {
      connectedCallback() {
        this.controller?.abort();
        this.controller = new AbortController();
        const options = {signal: this.controller.signal};
        const sortForm = this.querySelector('[data-ng-sort]');
        if (sortForm) {
          const select = sortForm.querySelector('select');
          sortForm.addEventListener('submit', event => {
            event.preventDefault();
            const url = new URL(location.href);
            url.searchParams.set('sort_by', select.value);
            url.searchParams.delete('page');
            location.assign(url.href);
          }, options);
          select.addEventListener('change', () => sortForm.requestSubmit(), options);
          sortForm.querySelector('button').hidden = true;
        }
        const filters = this.querySelector('[data-ng-filters]');
        if (filters) {
          const items = Array.from(this.querySelectorAll('[data-product-category]'));
          const buttons = Array.from(this.querySelectorAll('[data-category]'));
          const applyFilter = (requested = location.hash.slice(1)) => {
            const category = buttons.some(button => button.dataset.category === requested) ? requested : 'alla';
            let visible = 0;
            items.forEach(item => {
              item.hidden = category !== 'alla' && item.dataset.productCategory !== category;
              if (!item.hidden) visible += 1;
            });
            buttons.forEach(button => button.setAttribute('aria-pressed', String(button.dataset.category === category)));
            this.querySelector('[data-result-count]').textContent = visible;
          };
          buttons.forEach(button => {
            const count = items.filter(item => button.dataset.category === 'alla' || item.dataset.productCategory === button.dataset.category).length;
            button.querySelector('[data-count]').textContent = count;
            button.addEventListener('click', () => {
              // Render immediately; native hash navigation also preserves Back/Forward.
              applyFilter(button.dataset.category);
              if (location.hash !== `#${button.dataset.category}`) location.hash = button.dataset.category;
            }, options);
          });
          window.addEventListener('hashchange', () => applyFilter(), options);
          window.addEventListener('pageshow', () => applyFilter(), options);
          filters.hidden = false;
          applyFilter();
        }
        const videoNav = this.querySelector('.ng-video-nav');
        if (videoNav) {
          videoNav.hidden = false;
          videoNav.querySelectorAll('button').forEach(button => button.addEventListener('click', () => {
            const track = this.querySelector('.ng-video-track');
            track.scrollBy({left: Number(button.dataset.videoDirection) * (track.firstElementChild.getBoundingClientRect().width + 20), behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth'});
          }, options));
        }
      }
      disconnectedCallback() { this.controller?.abort(); }
    });
  }
  if (!customElements.get('ng-click-video')) {
    customElements.define('ng-click-video', class extends HTMLElement {
      connectedCallback() {
        this.controller?.abort();
        this.controller = new AbortController();
        const video = this.querySelector('video');
        const button = this.querySelector('button');
        button.addEventListener('click', () => {
          if (!video.src) video.src = video.dataset.src;
          video.hidden = false;
          button.hidden = true;
          video.focus();
          video.play().catch(() => { video.controls = true; });
        }, {signal: this.controller.signal});
        video.addEventListener('play', () => {
          document.querySelectorAll('ng-click-video video').forEach(other => { if (other !== video) other.pause(); });
        }, {signal: this.controller.signal});
      }
      disconnectedCallback() { this.controller?.abort(); this.querySelector('video')?.pause(); }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["press-popup-section"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('ng-press-modals')) {
    customElements.define('ng-press-modals', class extends HTMLElement {
      connectedCallback() {
        this.classList.add('ng-press-ready');
        this.controller?.abort();
        this.controller = new AbortController();
        const options = { signal: this.controller.signal };
        this.addEventListener('click', event => {
          if (event.target.closest('[data-close]') || event.target === this.activeModal) {
            this.closeModal();
            return;
          }
          const filter = event.target.closest('[data-press-filter]');
          if (filter) {
            this.querySelectorAll('[data-press-filter]').forEach(button => button.setAttribute('aria-pressed', String(button === filter)));
            this.querySelectorAll('.press-card').forEach(card => { card.hidden = filter.dataset.pressFilter !== 'all' && card.dataset.category !== filter.dataset.pressFilter; });
            return;
          }
          if (event.target.closest('a')) return;
          const card = event.target.closest('.press-card[data-popup]');
          if (!card) return;
          this.activeModal = this.querySelector(`[id="${card.dataset.popup}"]`);
          if (!this.activeModal) return;
          this.returnFocus = card.querySelector('button');
          this.previousOverflow = document.body.style.overflow;
          document.body.style.overflow = 'hidden';
          this.activeModal.hidden = false;
          this.activeModal.style.display = 'flex';
          this.activeModal.querySelector('[data-close]').focus();
        }, options);
        this.addEventListener('keydown', event => {
          if (!this.activeModal) return;
          if (event.key === 'Escape') {
            event.preventDefault();
            this.closeModal();
          } else if (event.key === 'Tab') {
            const focusable = Array.from(this.activeModal.querySelectorAll('button, a[href], input, select, textarea, [tabindex="0"]')).filter(element => !element.disabled && element.getClientRects().length);
            const first = focusable[0];
            const last = focusable[focusable.length - 1];
            if (event.shiftKey && document.activeElement === first) { event.preventDefault(); last.focus(); }
            else if (!event.shiftKey && document.activeElement === last) { event.preventDefault(); first.focus(); }
          }
        }, options);
      }
      closeModal() {
        if (!this.activeModal) return;
        this.activeModal.hidden = true;
        this.activeModal.style.display = 'none';
        this.activeModal = null;
        document.body.style.overflow = this.previousOverflow;
        this.returnFocus?.focus();
      }
      disconnectedCallback() { this.closeModal(); this.controller?.abort(); }
    });
  }

  } catch(e) { console.error(e); }
})();
})();
